import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./AddCard.css";

export default function AddCard() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");
  const [material, setMaterial] = useState("");
  const [color, setColor] = useState("");
  const [price, setPrice] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const categories = {
    Bedroom: ["Bed", "Wardrobe", "Dresser", "Dresser with Mirror", "Nightstand"],
    "Kids Bedroom": ["Kids Bed", "Wardrobe", "Desk", "Shelves"],
    "TV & Media": ["TV Stand", "TV Panel"],
    Decoration: ["Wall Panels", "Shelves", "Decor Units"],
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !summary || !category || !type || !price) {
      alert("Please fill all required fields");
      return;
    }

    if (!imageFile) {
      alert("Please select an image");
      return;
    }

    try {
      setUploading(true);
      const imageBase64 = await convertToBase64(imageFile);

      // ✅ Save to workCards collection
      await addDoc(collection(db, "workCards"), {
        title: title.trim(),
        summary: summary.trim(),
        description: description.trim(),
        category,
        type,
        material,
        color,
        price: Number(price),
        image: imageBase64,
        active: true,
        createdAt: serverTimestamp(),
      });

      navigate(-1);
    } catch (err) {
      console.error(err);
      alert("Failed to save card");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="add-card-container">
      <button onClick={() => navigate(-1)} className="back-btn">⬅ Back</button>

      <h1>Add Work Card</h1>

      <form onSubmit={handleSubmit} className="add-card-form">
        <input
          placeholder="Card Title *"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          placeholder="Short Summary *"
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
        />
        <textarea
          placeholder="Full Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* CATEGORY */}
        <select
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            setType("");
          }}
        >
          <option value="">Select Category *</option>
          {Object.keys(categories).map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        {/* TYPE */}
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          disabled={!category}
        >
          <option value="">Select Type *</option>
          {category &&
            categories[category].map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
        </select>

        <input
          placeholder="Material (e.g. MDF, Wood)"
          value={material}
          onChange={(e) => setMaterial(e.target.value)}
        />
        <input
          placeholder="Color (e.g. White, Oak)"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        />
        <input
          type="number"
          placeholder="Price (€) *"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
        />

        {imageFile && (
          <img
            src={URL.createObjectURL(imageFile)}
            alt="preview"
            className="preview-img"
          />
        )}

        <button type="submit" disabled={uploading}>
          {uploading ? "Saving..." : "Save Card"}
        </button>
      </form>
    </div>
  );
}
